import type { InjectionKey, Ref } from 'vue';
import type { SnapshotFrom } from 'xstate';
import {
  type BatchProcessEvent,
  batchProcessMachine
} from '@/machines/batchSignMachine';

export type BatchProcessSnapshot = SnapshotFrom<typeof batchProcessMachine>;

export interface BatchProcessMachineProvided {
  state: Ref<BatchProcessSnapshot>;
  send: (event: BatchProcessEvent) => void;
}

export const batchProcessMachineKey: InjectionKey<BatchProcessMachineProvided> =
  Symbol('batchProcessMachine');
